import { render, staticRenderFns } from "./ChooseMedicationView.vue?vue&type=template&id=05f3f728&"
import script from "./ChooseMedicationView.vue?vue&type=script&lang=ts&"
export * from "./ChooseMedicationView.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseMedicationView.vue?vue&type=style&index=0&id=05f3f728&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports